@if (TileInfo) {
  <a [routerLink]="getNavigationUrl(TileInfo)" class="mat-card-link-wrapper">
    <mat-card
      class="search-result-tile {{ TileInfo ? TileInfo.type.toLowerCase() : 'resource' }}"
      [routerLink]="getNavigationUrl(TileInfo)"
    >
      <mat-card-header title="{{ TileInfo ? TileInfo.type : 'Resource' }}" class="search-result-tile-header">
        @if (TileInfo.show_organization_logo == true) {
          <div mat-card-avatar class="search-result-tile-avatar">
            <img src="{{ getOrganizationLogo(TileInfo) }}" alt="{{ getOrganizationFullName(TileInfo) }}" />
          </div>
        }
        <mat-card-title class="search-result-tile-title">{{ TileInfo ? TileInfo.type : 'Resource' }}</mat-card-title>
      </mat-card-header>
      <mat-card-content class="search-result-tile-content">
        <div class="custom-image">
          <mat-icon title="{{ TileInfo.icon_alt }}" class="material-symbols-outlined standard-icon">{{
            TileInfo.icon
          }}</mat-icon>
        </div>
        <div class="title">{{ TileInfo.name }}</div>

        @if (TileInfo.event_metadata?.starts !== '') {
          <div class="metadata" [innerHTML]="TileInfo.event_metadata | eventMetadata: true"></div>
        }
      </mat-card-content>
    </mat-card>
  </a>
}
